export default {
  vodafoneLogo: {
    id: 'checkout_mobile_plan_step_vodafone_logo',
    defaultMessage: 'Vodafone logo',
  },
}
